import {BaseModel, DisableModel} from 'model/base.model';

export interface Tag extends BaseModel, DisableModel {
  id?: number;
  customerIds?: any;
}

export const defaultTag: Readonly<Tag> = {
};
